import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import IconButton from '@/components/IconButton.vue';
import i18n from '@/i18n';
import { resolveRuntimeEnvironment } from './config/runtimeEnvironment';

import '@/assets/css/bootstrap.min.css';
import '@/assets/css/bootstrap-overrides.css';
import '@/assets/css/style.css';
import '@/components/v2/index.css';
import '@/assets/css/dashboard-icons.css';

let app = createApp(App).use(router).use(i18n);

//===============================================
// Mixins

import AjaxMixin from './mixins/AjaxMixin';
import WindowDimensionsMixin from './mixins/WindowDimensionsMixin';
import SectorTerminologyMixin from './mixins/SectorTerminologyMixin';
app.mixin(AjaxMixin);
app.mixin(WindowDimensionsMixin);
app.mixin(SectorTerminologyMixin);

//===============================================
// Config environment (dev vs prod)

const hostname = window.location.hostname;
const { apiRoot, environment } = resolveRuntimeEnvironment({
    hostname,
    origin: window.location.origin,
    protocol: window.location.protocol,
    env: process.env,
});

app.config.globalProperties.$env = {
    apiRoot: apiRoot,
    environment: environment,
};

//===============================================
// Stores

import { createPinia } from 'pinia';
import { useUserStore } from './stores/user';
import { usePermissionStore } from './stores/permission';
import { useAlertStore } from './stores/alert';
import { useEmployeesStore } from './stores/employees';
import { useSiteStore } from './stores/site';
import { useRoleStore } from './stores/role';
import { configureProgramCatalog, useProgramStore } from './stores/programs';
import { configureAbxApi, useAbxStore } from './stores/abx';
import { useSupportStore } from './stores/support';
import { configureResidentsApi } from './stores/residents';
import { configureSurveillanceApi } from './stores/surveillance';

// Make frequently-used "user" store global for ease of access
let pinea = createPinia();
app.use(pinea);

app.config.globalProperties.$alertStore = useAlertStore();

const userStore = useUserStore();
app.config.globalProperties.$userStore = userStore;

const permissionStore = usePermissionStore();
app.config.globalProperties.$permStore = permissionStore;

const employeesStore = useEmployeesStore();
app.config.globalProperties.$employeesStore = employeesStore;

const siteStore = useSiteStore();
app.config.globalProperties.$siteStore = siteStore;

const roleStore = useRoleStore();
app.config.globalProperties.$roleStore = roleStore;

// Program visibility and access are always server-authoritative. A static
// catalog must never bypass the selected-site published-sector policy.
configureProgramCatalog({ apiRoot });
const programStore = useProgramStore();
app.config.globalProperties.$programStore = programStore;

configureAbxApi({ apiRoot });
const abxStore = useAbxStore();
app.config.globalProperties.$abxStore = abxStore;

// App admin support mode for one tab. See src/services/supportSession.js.
app.config.globalProperties.$supportStore = useSupportStore();

configureResidentsApi({ apiRoot });
configureSurveillanceApi({ apiRoot });

app.component('IconButton', IconButton);

app.mount('#app');
export default app;
